import { AppIconProps } from "../../types/webos";

export function AppIcon({ app, onClick, size = "medium" }: AppIconProps) {
  const handleClick = () => {
    onClick(app);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick(app);
    }
  };

  const iconStyle = {
    width: size === "small" ? "48px" : size === "large" ? "120px" : "256px",
    height: size === "small" ? "48px" : size === "large" ? "120px" : "256px",
    fontSize: size === "small" ? "18px" : size === "large" ? "48px" : "128px",
  };

  return (
    <div className="app-icon-container">
      <button
        className="webos-app-icon"
        style={iconStyle}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        aria-label={`Launch ${app.name}`}
        tabIndex={0}
      >
        <span>{app.icon}</span>
      </button>

      <span className="app-name">{app.name}</span>
    </div>
  );
}
